import React from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Approach } from "@/components/site/Approach";
import { Services } from "@/components/site/Services";
import { Reach } from "@/components/site/Reach";
import { Payments } from "@/components/site/Payments";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

function App() {
  useLenis();
  return (
    <LanguageProvider>
      <div className="App bg-[#0A0A0B] text-white min-h-screen">
        <div className="flo-noise" />
        <Navbar />
        <main>
          <Hero />
          <Ribbon />
          <Approach />
          <Services />
          <Reach />
          <Payments />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster theme="dark" position="top-center" />
      </div>
    </LanguageProvider>
  );
}

export default App;
